import { render } from "./ClusterFormation.vue?vue&type=template&id=8aba60f4&scoped=true"
import script from "./ClusterFormation.vue?vue&type=script&lang=js"
export * from "./ClusterFormation.vue?vue&type=script&lang=js"

import "./ClusterFormation.vue?vue&type=style&index=0&id=8aba60f4&scoped=true&lang=css"
import "./ClusterFormation.vue?vue&type=style&index=1&id=8aba60f4&lang=scss"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8aba60f4"]])

export default __exports__